export default "You have been taken. You wake up in a basement, chained to each other and the wall. Can you escape before your kidnapper returns?";